import React from 'react';
import ErrorBoundary from '@/ErrorBoundary';
import {appBaseName} from '@/config';

import Header from '@/views/Layout/b2c/Header';
import Footer from '@/views/Layout/b2c/Footer';

// b2c
import B2cRouterSwitch from '@/b2c/Routes';

const B2c = ({match}) => (
  <>
    <link rel='stylesheet' href={`${appBaseName}/assets/css/b2c_base.css`} />
    <link rel='stylesheet' href={`${appBaseName}/assets/css/b2c_main.css`} />
    <Header />
    <ErrorBoundary>
      <main className='container'>
        <B2cRouterSwitch match={match} />
      </main>
    </ErrorBoundary>
    <Footer />
  </>
);

export default B2c;
